import React from 'react';
import { evrCumulativeColor } from '../../../constants/colors';
import { evrRollingColor } from '../../../constants/colors';
import AdmIntervalChartWrapper from '../adm_shared/AdmIntervalChartWrapper';

export default function AdmEvrChart(props) {
  const { evr, increment, d0_interval, d2_interval } = props;

  return (
    //admNivoChart is also another option
    <AdmIntervalChartWrapper
      title='EVR Chart'
      evr={evr}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      arrivalColor={evrCumulativeColor}
      closureColor={evrRollingColor}
      showArrival={false}
      showClosure={false}
      yMax={3}
    />
  );
}
